import { useTranslation } from 'react-i18next';
import { backdropClose } from '../lib/modalBackdrop';

interface CloudOption {
  name: string;
  icon: string;
  url: string;
}

const CLOUD_OPTIONS: CloudOption[] = [
  { name: 'cloudLimitModalYandexDisk', icon: '/cloud-yandex.svg', url: 'https://disk.yandex.ru/' },
  { name: 'OneDrive', icon: '/cloud-onedrive.svg', url: 'https://onedrive.live.com/' },
  { name: 'Google Drive', icon: '/cloud-gdrive.svg', url: 'https://drive.google.com/' },
];

/**
 * Показывается вместо обычного тоста, когда файл превышает серверный лимит размера
 * (413 от /api/v1/media) — отправка уже прервана самой ошибкой загрузки, здесь только
 * предлагаем альтернативу: залить файл в облако и прислать на него ссылку.
 */
export default function CloudLimitModal({ message, onClose }: { message: string; onClose: () => void }) {
  const { t } = useTranslation('misc2');
  return (
    <div className="modal-backdrop" {...backdropClose(onClose)}>
      <div className="modal cloud-limit-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" title={t('misc:cloudLimitClose')} onClick={onClose}>✕</button>
        <h2>{t('misc:cloudLimitTitle')}</h2>
        <p className="cloud-limit-text">{t('misc:cloudLimitDescription', { message })}</p>
        <div className="cloud-limit-options">
          {CLOUD_OPTIONS.map((o) => (
            <a key={o.name} className="cloud-limit-option" href={o.url} target="_blank" rel="noreferrer">
              <img src={o.icon} alt="" />
              <span>{o.name === 'cloudLimitModalYandexDisk' ? t('cloudLimitModalYandexDisk') : o.name}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
